import {Component} from "react";
import "./css/ManualRegister.css";
import {filter} from "./Actions";

export default class ManualRegister extends Component {
    render() {
        return (
            <div className="manual-register d-none">
                <div className="header">
                    REGISTRO MANUAL DE ASISTENTES
                </div>
                <div className="searcher">
                    <label htmlFor="">BUSCAR POR NOMBRE</label>
                    <input type="search" name="" id="" onKeyUp={filter}/>
                </div>
                <div className="list">
                </div>
            </div>
        )
    }
}